export const ORGANIZATION_LOGO_AND_ICON_SECTIONS_HEIGHT = 154
